/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description:主题切换
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-06-14 22:50:18
 * @LastEditTime: 2022-12-24 11:25:03
 * @FilePath: /client-h5-v2/src/theme/themeChalk.ts
 */
/**
 *
 * @param {*} theme
 * 获取传入类型的样式文件, 然后使用 JS 设置, CSS 变量的样式
 *
 */
export function setTheme (theme = 'light') {
  // 获取样式信息
  const themeMap:any = getThemeList(theme)
  // 获取根节点
  const body = document.body
  // 循环给根节点的 CSS 变量赋值
  Object.keys(themeMap).forEach(key => {
    // 这里使用-- 作为前缀名, 是为了区分变量名
    body.style.setProperty(`--${key}`, themeMap[key])
  })
}

/**
 *
 * @param {*} theme
 * 根据传入的样式风格, 返回不同的样式
 * 深浅色模式
 *
 */
export function getThemeList (key: string) {
  const themeList:any = {
    light: () => require('@/theme/light'),
    drak: () => require('@/theme/drak'),
    xiaoleTheme1: () => require('@/theme/xiaole/theme1'),
    xiaoleTheme2: () => require('@/theme/xiaole/theme2'),
    xiaoleTheme3: () => require('@/theme/xiaole/theme3'),
    xiaoleMobile: () => require('@/theme/xiaole/mobile'),
    lenaTheme1: () => require('@/theme/lena/theme1'),
    lenaMobile1: () => require('@/theme/lena/mobile'),
    zhilianDrak: () => require('@/theme/zhilian/drak'),
    zhilianLight1: () => require('@/theme/zhilian/light1')
  }
  return themeList[key]().default ? themeList[key]().default : themeList.light().default
}

export function setBackgroundImage (url: string):void {
  document.body.style.backgroundImage = `url(${url})`
}
